module.exports = __webpack_public_path__ + "01_short_black.86d9edde.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_short_black.png
// module id = xUW+
// module chunks = 0